import { orderUploadErrorsModalStyles } from "@insite/content-library/Components/OrderUploadErrorsModal";
import { css } from "styled-components";

orderUploadErrorsModalStyles.cancelUploadButton = {
    variant: "secondary",
    css: css`
        @media only screen and (max-width: 415px) {
            width: 100%;
        }
    `,
};

orderUploadErrorsModalStyles.continueUploadButton = {
    css: css`
        margin-left: 10px;
        @media only screen and (max-width: 415px) {
            margin-left: 0px;
            margin-top: 10px;
            width: 100%;
        }
    `,
};
